import Vue from "vue";
import QRious from "qrious";
import JsBarcode from "jsbarcode";



export default {

  printInformar(prosecution) {

    const office = prosecution.office;
    const company = prosecution.office.company;
    const procesamiento = prosecution.procesamiento;
    const venta = prosecution.venta;
    const customer = prosecution.venta.customer;
    const doctor = prosecution.venta.doctor;
    const procesamientoDetalle = prosecution.procesamientoDetalle;
    const history = prosecution.history;
    const imagen_url = prosecution.procesamiento?.nameFile
      ? prosecution.procesamiento.routeFile +
        prosecution.procesamiento?.nameFile
      : "";
    let imgCompleta = "";

    if (imagen_url.length > 0) {
      // if (imgBase64) {
      
      imgCompleta = `<img src="${process.env.VUE_APP_API_URL_BASE + "/" +  imagen_url}" alt="logo_img" style="width: 450px; height: 300px; margin-top:30px;">`;

    }

    const color1 = "#048A00"; // ? color green
    // const color1 = "#C40E0E"; // ? color red
    const color2 = "#00BAD3"; // ? color blue
    const color3 = "#9C9C9C"; // ? color gray

    const calcularEdad = (fecha) => {
      var hoy = new Date();
      var cumpleanos = new Date(fecha);
      var edad = hoy.getFullYear() - cumpleanos.getFullYear();
      var m = hoy.getMonth() - cumpleanos.getMonth();

      if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
        edad--;
      }

      return edad;
    };

    const edad = calcularEdad(customer.born_date);

    const formatDate = (date, hour=false) => {
      let formatted_date =
        date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();

      if(!hour)return formatted_date;
      return formatted_date + ' ' + date.toLocaleTimeString()
    };
    const day = formatDate(new Date(), true);
    // const hour = new Date().toLocaleTimeString();

    let registration_date = new Date(venta.registration_date);
    registration_date =
      formatDate(registration_date) +
      " " +
      registration_date.toLocaleTimeString();

    let procesamiento_create = new Date(procesamiento.created_at);
    procesamiento_create =
      formatDate(procesamiento_create) +
      " " +
      procesamiento_create.toLocaleTimeString();

    // ! codigo qr

    const link =
      window.location.origin +
      `/#/validate-pdf?id_sale=${venta.id}&id_procesamiento=${procesamiento.id}`;
    const qr = new QRious({
      value: link, // La URL o el texto
      size: 500,
      backgroundAlpha: 0, // 0 para fondo transparente
      foreground: "#000000", // Color del QR
      level: "H", // Puede ser L,M,Q y H (L es el de menor nivel, H el mayor)
    });

    setTimeout(function() {}, 800);


    // ! codigo de barras
    const codigo = "S-00" + String(venta.id);

    let date = "";
    // !obtener la fecha del history
    history.forEach((item) => {
      date =
        date +
        `<label>${
          item.prosecution
            ? formatDate(new Date(item.prosecution.date_process))
            : "-"
        }</label>`;
    });

    let dateWithHour = procesamiento.date_hora_muestra

    if(dateWithHour){
      // ! parsea fecha de toma de muestra
      if(procesamiento.hour_toma_muestra){
        dateWithHour = formatDate(new Date(dateWithHour), false)  + " " + procesamiento.hour_toma_muestra
      }else {
        dateWithHour = formatDate(new Date(dateWithHour), true)
      }
    }

    let content = "";
    let count = 1;
    procesamientoDetalle.map((item) => {
      if (!item.active || !item.check) return;
      let className = "";
      if (count % 2 == 0) {
        className = "underlined-row";
      }

      let unit_name_aux = item.unit_name == "NO TIENE" || item.unit_name == null ? "" : item.unit_name 

      const rank = item.rank || "";
      let newRank = rank.replaceAll("<p>", `<label>`);
      newRank = newRank.replaceAll("</p>", ` ${unit_name_aux} </label>`);

      let description1 =  item.description1 || ""
      description1 = description1.replaceAll("<p>", "<label>");
      description1 = description1.replaceAll("</p>", "</label>");

      let description2 =  item.description2 || ""
      description2 = description2.replaceAll("<p>", "<label>");
      description2 = description2.replaceAll("</p>", "</label>");

      let sizeForDescription = "height: 15px;"
      if(description2.length > 0 && description1.length > 0) sizeForDescription = "height: 70px;"

      if(description2.length > 0 || description1.length > 0)sizeForDescription = "height: 20px;"
      

      // ! cuando es cabecera
      // if (item.service_detail_id == null) {
      if (item.index == -1) {
        // ! cuando es compuesto
        if (item.iscompound == "on ") {
          content =
            content +
            `<tr class="tr-analisis">
              <td  style="padding:5px 0;" class="name-sub-analisis"> 
                <div style="padding-bottom: 5px;">
                  <label class="name-analisis " style="font-size: 11px !important;"> ${item.name} </label>
                  <div style="display:flex; flex-direction: column; font-size: 9px;">
                      ${description1}
                      ${description2}
                  </div>  
                </div>
              </td>
          </tr>`;
        } else {
          content =
            content + `
            
            <tr class="tr-analisis " >
              <td colspan="3">
                <table style="width: 100%;">
                  <tbody style="width: 100%;">
                    <tr>
                      <td class="name-sub-analisis" style="width:38%;">
                        <div style="display:flex; flex-direction: column;">
                          <label style="font-size: 11px !important; font-weight:700;">
                            ${item.name}
                          </label>
                        </div>  
                      </td>
                      <td class="table-answer-tr"  rowspan="3" style="width:31%; font-size:11px !important; " valign="bottom">
                          ${item.result ? item.result : ""} ${ " "} ${unit_name_aux}  
                      </td>
                      <td class="table-answer-tr"  rowspan="3" style=" font-size:10px !important; "  valign="bottom"> 
                        <div style="display: flex; flex-direction: column;">
                          ${newRank} 
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div style="display:flex; flex-direction: column; font-size: 9px;">
                          ${description1}
                          ${description2}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
          </tr>
          `;
        }
      } else {
        // ! cuando es subanalisis
        content =
          content +
          ` <tr class="tr-analisis ">
              <td colspan="3">
                <table style="width: 100%;">
                  <tbody>
                    <tr>
                      <td class="name-sub-analisis" style="width:38%;">
                        <div style="display:flex; flex-direction: column;">
                          <label style="font-size: 11px !important;">
                            ${item.name}
                          </label>
                        </div>  
                      </td>
                      <td class="table-answer-tr"  rowspan="3" style="width:31%; font-size:11px !important; " valign="bottom">
                          ${item.result ? item.result : ""} ${ " "} ${unit_name_aux }  
                      </td>
                      <td class="table-answer-tr"  rowspan="3" style=" font-size:10px !important; "  valign="bottom"> 
                        <div style="display: flex; flex-direction: column;">
                          ${newRank} 
                        </div>
                      </td> 
                    </tr>
                    <tr>
                      <td>
                        <div style="display:flex; flex-direction: column; font-size: 9px;">
                          ${description1}
                         
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div style="display:flex; flex-direction: column; font-size: 9px;">
                        ${description2}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
          </tr>
        `;
      }

      count++;
    });

    // <tr class="tr-analisis ">
    //         <td class="name-analisis name-sub-analisis" >
    //           <div>
    //             <label class="name-analisis " style="font-size: 11px !important;"> ${item.name} </label>
    //             <div style="display:flex; flex-direction: column; font-size: 9px; ">
    //                 ${description1}
    //                 ${description2}
    //             </div>  
    //           </div>  
    //           </td>
    //         <td class="table-answer-tr" style="font-size:11px !important;">${item.result ? item.result : ""}  ${ " "} ${item.unit_name ? item.unit_name : ""}</td>
    //         <td class="table-answer-tr" style="font-size:10px !important; display: flex; flex-direction: column; padding:3px 0 3px 5px;"> ${newRank} </td>      
    //       </tr>

    const styleAux = `
  <style type="text/css" media="screen, print">

  @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

    .thin {
        /* Montserrat Thin = 100 */
        font-weight: 100;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    .extralight {
        /* Montserrat Extra Light = 200 */
        font-weight: 200;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .light {
        /* Montserrat Light = 300 */
        font-weight: 300;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .regular {
        /* Montserrat Regular = 400 */
        font-weight: 400;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .medium {
        /* Montserrat Medium = 500 */
        font-weight: 500;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .semibold {
        /* Montserrat Semi-bold = 600 */
        font-weight: 600;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .bold {
        /* Montserrat Bold = 700 */
        font-weight: 700;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .extrabold {
        /* Montserrat Extra Bold = 800 */
        font-weight: 800;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .black {
        /* Montserrat Black = 900 */
        font-weight: 900;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }

    body {
        margin: 0cm 0cm;
        font-size: 12px;
        font-family: 'Open Sans', sans-serif;
    }

  /* Styles go here */

.page-header, .page-header-space {
  height: 210px;
}

.page-footer, .page-footer-space {
  height: 260px;
}

.cabecera {
    display: flex;
    height: 80px;
    width: 100%;
}

.nameInfo {
    color: black;
    font-weight: bold;
}

.answerInfo {
      color: #616161;
      font-weight: 500;
      padding-Left:4px;
}

.table-cabecera-name {
  width:33%;  
  text-align: start;
  text-decoration: underline;
  padding: 5px 0 15px 0;
  font-weight: 700;
  font-size: 11px;

}

.page-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 150px !important;

  border-top: 1px solid black; /* for demo */
}

.page-header {
  position: fixed;
  width: 100%;
}

.tr-analisis {
    color: #000000;

}

.tr-sub-analisis {
    color: #000000;
}

.underlined-row {
    background-color: #F8F8F8;
}

.custom-section {
  padding: 20px 50px 0px 50px;
}

.name-analisis {
  font-weight: 700;
  font-size:14px;
  text-transform: uppercase;
}

.name-sub-analisis {
    
    text-transform: uppercase;
}

.table-answer-tr {
    font-size: 15px;
}

.page {
  page-break-after: always;
}

@page {
  margin: 20mm
}

footer {
    position: fixed;
    bottom: 0;
    width: 100%;
  }

@media print {
   thead {display: table-header-group;} 
   tfoot {display: table-footer-group;}
   
   button {display: none;}
   
   body {margin: 0;}
} 
</style>
`;

    const section01 = `
    <section style="padding: 20px 50px 0px 50px; padding-right:0 !important" >
      <div class="cabecera" >
          <!-- logos -->
          <div style="display:flex; width: 40%;">
              <div style="display:flex; width: 80%; height: 90%;">
                  <img src="img/${company.img_url}" alt="logo"
                  style="width: 100%; height: 100%;">
              </div>
          </div>
          <div style="display:flex; width: 60%; justify-content:end;">
            <div style="display:flex; background-color:#CAEFF1; justify-content:center; padding:0 15px 0 20px; border-top-left-radius: 80px 80px; border-bottom-left-radius: 80px 80px; align-items: center;">
              <label style="display:flex; width: 70%; font-size:20px; text-align: end; font-weight: 600; color:#27b5d4;">Laboratorio de Analisis Clinicos</label>
            </div>
          </div>
      </div>
    </section>
    `;

    const section02 = `
    <section style="padding: 14px 70px 0px 70px;">
        <div style="display: flex; width: 100%;">
            <div style="display: flex; flex-direction: column; width: 100%; font-size: 12px; font-weight: bold;">
                  
                <div style="display: flex; align-items: center;">
                    <div style=" display: flex; width: 60%;">
                      <label for="" class="nameInfo">PACIENTE : </label>
                      <label for="" class="answerInfo">${
                        customer.fullname ? customer.fullname : ""
                      }</label>
                    </div>
                </div>

                <div style="display: flex; align-items: center; padding-top:4px;">
                    <label for="" class="nameInfo">MEDICO / SOLICITANTE  : </label>
                    <label for="" class="answerInfo">${
                      doctor ? doctor.fullname : ""
                    }</label>
                </div>

                

                <div style="display: flex; margin-top:4px; align-items: center;">
                    <div style=" display: flex; width: 65%; align-items: center;">
                      <label for="" class="nameInfo">EDAD : </label>
                      <label for="" class="answerInfo">${edad} años</label>
                    </div>
                </div>

                <div style="display: flex; margin-top:4px; align-items: center;">
                    <div style=" display: flex; width: 65%; align-items: center;">
                      <label for="" class="nameInfo">DNI : </label>
                      <label for="" class="answerInfo">${
                        customer.document ? customer.document : ""
                      }</label>
                    </div>
                    
                </div>
                <div style="display: flex; align-items: center; padding-top:4px;">
                    <div style=" display: flex; width: 40%; align-items: center;">
                      <label for="" class="nameInfo">FEC/HORA T.M : </label>
                      <label for="" class="answerInfo"> ${dateWithHour ? dateWithHour + " HRS" : '___-___-_____/ ___:___ HRS'} </label>
                    </div>
                    <div style=" display: flex; width: 60%; align-items: center;">
                      <label for="" class="nameInfo">FEC. EMISIÓN : </label>
                      <label for="" class="answerInfo"> ${day} HRS</label>
                    </div>

                </div>
            </div>
        </div>

        <div style="position:absolute; top:130px; right:50px;">
          <div style="display: flex; align-items: center; flex-direction: column; ">
            <div style="position:relative;">
              <svg id="barcode" style="display:flex; width: 20%!important; height: 8%!important;"></svg>
              <div style="position:absolute; bottom:-5px; left:40%; ">
                <label style="display:flex; ">${codigo}</label>
              </div>
            </div>
          </div>
        </div>

    </section>`;

    const section03 = `
    <section style="padding: 0px 70px 5px 70px; ">
            <table style="width: 100%; font-size:11px;">
                <thead>
                    <tr>
                      <th class="table-cabecera-name" style="width: 38% !important">ANÁLISIS</th>
                      <th class="table-cabecera-name" style="width: 31% !important">RESULTADOS</th>
                      <th class="table-cabecera-name" style="">RANGO REFERENCIAL</th>
                    </tr>
                </thead>
                <tbody style="font-size:10px;">
                    ${content}
                </tbody>
            </table>
            <div style="display:flex; justify-content: center;">
              ${imgCompleta}
            </div>
        </section>
    `;

    const footer = `
    <footer >
      <div style="display: flex; width:100%; justify-content: space-between; padding-bottom:10px; margin: 0 45px;">
        <div style="display:flex; flex-direction: column; width:50%; padding-left:10%;">
          <label style="font-size: 11px; font-weight: bold;">QR Evite Falsificaciones</label>
          <div style="display:flex; width:80px; height:75px; margin-top:2px; margin-left:5%;">
            <img src="${qr.image.src}" style="width: 100%; height: 100%;"></img>
          </div>
        </div>

        <div style="display:flex; width:50%; justify-content: center;">
          <div style="text-align: end; padding-right: 8%; padding-bottom: 3%;">
              <img src="img/firma_doctor-background.png" alt="firma" style="width: 180px; height: 100px;">
          </div>
        </div>
      </div>

      <div style="display:flex; color:#45a02b; padding: 0 45px; font-size:18px; font-weight:700; margin-top:10px;">
        <label>${office.name}</label>
        <img src="svg/phone-icon.svg" style="width: 25px; height: 18px; margin-left:8px;"></img>
        <label style="margin-left:4px;">${office.phone}</label>
      </div>

      <div style="display:flex;  background-color:#27b5d4; height:1.5px; margin: 10px 45px; "></div>

      <div style="color:#27b5d4; padding: 0 45px 30px 45px;">
        <div style="display:flex; justify-content: space-between; margin-bottom:8px;">
          <div>
            <img src="svg/placeholderlocalization.svg" style="width: 25px; height: 18px; margin-left:8px;"></img>
            <label>${office.address}</label>
          </div>
          <label>Contactanos</label>
        </div>
        <div style="display:flex; justify-content: space-between; margin-bottom:8px;">
          <div>
            <img src="svg/placeholderlocalization.svg" style="width: 25px; height: 18px; margin-left:8px;"></img>
            <label>av. central</label>
          </div>
          <div style="display:flex; ">
            <div style="display:flex;">
              <img src="svg/facebook.svg" style="width: 25px; height: 18px; margin-left:8px;"></img>
              <label>Tomolab</label>
            </div>
            <div style="display:flex;">
              <img src="svg/instagram.svg" style="width: 25px; height: 18px; margin-left:8px;"></img>
              <label>tomolab_</label>
            </div>
          </div>
        </div>
      </div>
    </footer>`;

    return (
      `<head>
    <script src="https://unpkg.com/qrious@4.0.2/dist/qrious.js"></script>
    <script src="js/JsBarcode.all.min.js"></script>
    </head>` +
      styleAux +
      `<body>

      <div class="page-header">
        <header >
            ${section01}
            
            <!-- info de paciente -->
            ${section02}
        </header>
      </div>

      <table style=" width:100%;">

        <thead>
          <tr>
            <td>
              <div class="page-header-space"></div>
            </td>
          </tr>
        </thead>

        <tbody >
          <tr >
            <td >
            ${section03}
            </td>
          </tr>
        </tbody>

        <tfoot>
          <tr>
            <td>
              <div class="page-footer-space">
               
              </div>
            </td>
          </tr>
        </tfoot>

      </table>
      ${footer}
    </body>
    <script>
      JsBarcode("#barcode", "${codigo}", {
        format: "CODE39",
        lineColor: "#000",
        width: 1.2,
        height: 30,
        displayValue: false
      });
    </script>
    `
    );
  },

  printInformarNewDisenio(prosecution) {

    // let analisisForQr = prosecution.procesamientoDetalle.filter((dt)=> dt.index == -1 && dt.active && dt.check)

    const office = prosecution.office;
    const company = prosecution.office.company;
    const procesamiento = prosecution.procesamiento;
    const venta = prosecution.venta;
    const customer = prosecution.venta.customer;
    const doctor = prosecution.venta.doctor;
    const procesamientoDetalle = prosecution.procesamientoDetalle;
    const history = prosecution.history;
    const imagen_url = prosecution.procesamiento?.nameFile
      ? prosecution.procesamiento.routeFile +
        prosecution.procesamiento?.nameFile
      : "";
    let imgCompleta = "";

    if (imagen_url.length > 0) {
      // if (imgBase64) {
      
      imgCompleta = `<img src="${process.env.VUE_APP_API_URL_BASE + "/" +  imagen_url}" alt="logo_img" style="width: 450px; height: 300px; margin-top:30px;">`;

    }

    const color1 = "#048A00"; // ? color green
    // const color1 = "#C40E0E"; // ? color red
    const color2 = "#00BAD3"; // ? color blue
    const color3 = "#9C9C9C"; // ? color gray

    const calcularEdad = (fecha) => {
      var hoy = new Date();
      var cumpleanos = new Date(fecha);
      var edad = hoy.getFullYear() - cumpleanos.getFullYear();
      var m = hoy.getMonth() - cumpleanos.getMonth();

      if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
        edad--;
      }

      return edad;
    };

    const edad = calcularEdad(customer.born_date);

    const formatDate = (date, hour=false) => {
      let formatted_date =
        date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();

      if(!hour)return formatted_date;
      return formatted_date + ' ' + date.toLocaleTimeString()
    };
    const day = formatDate(new Date(), true);
    // const hour = new Date().toLocaleTimeString();

    let registration_date = new Date(venta.registration_date);
    registration_date =
      formatDate(registration_date) +
      " " +
      registration_date.toLocaleTimeString();

    let procesamiento_create = new Date(procesamiento.created_at);
    procesamiento_create =
      formatDate(procesamiento_create) +
      " " +
      procesamiento_create.toLocaleTimeString();

   

    setTimeout(function() {}, 800);


    // ! codigo de barras
    const codigo = "S-00" + String(venta.id);

    let date = "";
    // !obtener la fecha del history
    history.forEach((item) => {
      date =
        date +
        `<label>${
          item.prosecution
            ? formatDate(new Date(item.prosecution.date_process))
            : "-"
        }</label>`;
    });

    let dateWithHour = procesamiento.date_hora_muestra

    if(dateWithHour){
      // ! parsea fecha de toma de muestra
      if(procesamiento.hour_toma_muestra){
        dateWithHour = formatDate(new Date(dateWithHour), false)  + " " + procesamiento.hour_toma_muestra
      }else {
        dateWithHour = formatDate(new Date(dateWithHour), true)
      }
    }

    let content = "";
    let count = 1;
    const analisisForQr = []
    procesamientoDetalle.map((item) => {
      if (!item.active || !item.check) return;
      let className = "";
      if (count % 2 == 0) {
        className = "underlined-row";
      }

      let unit_name_aux = item.unit_name == "NO TIENE" || item.unit_name == null ? "" : item.unit_name 

      const rank = item.rank || "";
      let newRank = rank.replaceAll("<p>", `<label>`);
      newRank = newRank.replaceAll("</p>", ` ${unit_name_aux} </label>`);

      let description1 =  item.description1 || ""
      description1 = description1.replaceAll("<p>", "<label>");
      description1 = description1.replaceAll("</p>", "</label>");

      let description2 =  item.description2 || ""
      description2 = description2.replaceAll("<p>", "<label>");
      description2 = description2.replaceAll("</p>", "</label>");

      let sizeForDescription = "height: 15px;"
      if(description2.length > 0 && description1.length > 0) sizeForDescription = "height: 70px;"

      if(description2.length > 0 || description1.length > 0)sizeForDescription = "height: 20px;"
      
      let infoMachineInput = ""
      if(item.infoMachine && item.infoMachineInput != null){

        infoMachineInput = `
                <tr >
                  <td style="font-size: 9px;" >
                    ${item.infoMachineInput}
                  </td>
                </tr>
              `
      }

      

      let complementaryResult = ""
      if(item.complementaryResult && item.complementaryResultInput != null){
        let complementaryResultInput = item.complementaryResultInput.replaceAll("<p", '<pre style="line-height: 2px !important;"')
        complementaryResultInput = complementaryResultInput.replaceAll("p>", "pre>")
        
        complementaryResult = `
                <tr >
                  <td colspan="3">
                    ${complementaryResultInput}
                  </td>
                </tr>
              `
      }

      let commentResult = ""
      if(item.commentResult && item.commentInput != null){
        let commentInput = item.commentInput.replaceAll("<p", '<pre style="line-height: 2px !important;"')
        commentInput = commentInput.replaceAll("p>", "pre>")
        
        commentResult = `
                <tr >
                  <td colspan="3" >
                    ${commentInput}
                  </td>
                </tr>
              `
      }


      // ! cuando es cabecera
      // if (item.service_detail_id == null) {
      if (item.index == -1) {
        // ! cuando es compuesto
        if (item.iscompound == "on ") {
          let band = false;

          const moreServiceWithId = procesamientoDetalle.filter((dt)=> dt.prosecution_detail_id == item.id && dt.index != -1)
          if(moreServiceWithId.length > 0){
            console.log("nueva configuracion")
            // si hay prosecution_detail_id -> referencias
            // ahora verificar cuales estan activas
            const moreServiceWithIdActivas = moreServiceWithId.filter((dt)=> dt.check)
            if(moreServiceWithIdActivas.length > 0) band = true
          }else {
            console.log("antigua configuracion")
            const moreServiceWithId = procesamientoDetalle.filter((dt)=> dt.service_id == item.service_id && dt.check && dt.index != -1)

            if(moreServiceWithId.length > 1) band = true;
          }

          if(band){

            analisisForQr.push(item)
            content =
              content +
              `<tr class="tr-analisis">
                <td  style="padding:5px 0;" class="name-sub-analisis"> 
                  <div style="padding-bottom: 5px;">
                    <label class="name-analisis " style="font-size: 11px !important;"> ${item.name} </label>
                    <div style="display:flex; flex-direction: column; font-size: 9px;">
                        ${description1}
                        ${description2}
                    </div>  
                  </div>
                </td>
            </tr>`;
          }
          

        } else {
          analisisForQr.push(item)
          content =
            content + `
            
            <tr class="tr-analisis " >
              <td colspan="3">
                <table style="width: 100%;">
                  <tbody style="width: 100%;">
                    <tr>
                      <td class="name-sub-analisis" style="width:38%;">
                        <div style="display:flex; flex-direction: column;">
                          <label style="font-size: 11px !important; font-weight:700;">
                            ${item.name}
                          </label>
                        </div>  
                      </td>
                      <td class="table-answer-tr"  rowspan="3" style="width:31%; font-size:11px !important; " valign="bottom">
                          ${item.result ? item.result : ""} ${ " "} ${unit_name_aux}  
                      </td>
                      <td class="table-answer-tr"  rowspan="3" style=" font-size:10px !important; "  valign="bottom"> 
                        <div style="display: flex; flex-direction: column;">
                          ${newRank} 
                        </div>
                      </td>
                    </tr>
                    ${infoMachineInput}
                    <tr>
                      <td>
                        <div style="display:flex; flex-direction: column; font-size: 9px;">
                          ${description1}
                          ${description2}
                        </div>
                      </td>
                    </tr>
                    
                  </tbody>
                </table>
              </td>
          </tr>
          
          ${complementaryResult}
          ${commentResult}
          `;
        }
      } else {
        // ! cuando es subanalisis
        content =
          content +
          
          ` 
          ${infoMachineInput}
          <tr class="tr-analisis " >
              <td colspan="3">
                <table style="width: 100%;">
                  <tbody>
                    <tr>
                      <td class="name-sub-analisis" style="width:38%;">
                        <div style="display:flex; flex-direction: column;">
                          <label style="font-size: 11px !important;">
                            ${item.name}
                          </label>
                        </div>  
                      </td>
                      <td class="table-answer-tr"  rowspan="3" style="width:31%; font-size:11px !important; " valign="bottom">
                          ${item.result ? item.result : ""} ${ " "} ${unit_name_aux }  
                      </td>
                      <td class="table-answer-tr"  rowspan="3" style=" font-size:10px !important; "  valign="bottom"> 
                        <div style="display: flex; flex-direction: column;">
                          ${newRank} 
                        </div>
                      </td> 
                    </tr>
                    ${infoMachineInput}
                    <tr>
                      <td>
                        <div style="display:flex; flex-direction: column; font-size: 9px;">
                          ${description1}
                         
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div style="display:flex; flex-direction: column; font-size: 9px;">
                        ${description2}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
          </tr>
          
          ${complementaryResult}
          ${commentResult}
        `;
      }

      count++;
    });

     // ! codigo qr

    let paramsForQr = ""
    analisisForQr.map((dt)=> {
      if(paramsForQr.length > 2) paramsForQr = paramsForQr + "," + dt.name
      else paramsForQr = dt.name
    })

    // const link = window.location.origin + `/#/validate-pdf?id_sale=${venta.id}&id_procesamiento=${procesamiento.id}`;
    const link = 'https://resultados.tomolab.com.pe:81' + `/#/validate-pdf?id_sale=${venta.id}&id_procesamiento=${procesamiento.id}&analisis=${paramsForQr}`;
    // console.log(link)
    const qr = new QRious({
      value: link, // La URL o el texto
      size: 500,
      backgroundAlpha: 0, // 0 para fondo transparente
      foreground: "#000000", // Color del QR
      level: "H", // Puede ser L,M,Q y H (L es el de menor nivel, H el mayor)
    });

    

    // <tr class="tr-analisis ">
    //         <td class="name-analisis name-sub-analisis" >
    //           <div>
    //             <label class="name-analisis " style="font-size: 11px !important;"> ${item.name} </label>
    //             <div style="display:flex; flex-direction: column; font-size: 9px; ">
    //                 ${description1}
    //                 ${description2}
    //             </div>  
    //           </div>  
    //           </td>
    //         <td class="table-answer-tr" style="font-size:11px !important;">${item.result ? item.result : ""}  ${ " "} ${item.unit_name ? item.unit_name : ""}</td>
    //         <td class="table-answer-tr" style="font-size:10px !important; display: flex; flex-direction: column; padding:3px 0 3px 5px;"> ${newRank} </td>      
    //       </tr>

    const styleAux = `
  <style type="text/css" media="screen, print">

  @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

    .thin {
        /* Montserrat Thin = 100 */
        font-weight: 100;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    .extralight {
        /* Montserrat Extra Light = 200 */
        font-weight: 200;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .light {
        /* Montserrat Light = 300 */
        font-weight: 300;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .regular {
        /* Montserrat Regular = 400 */
        font-weight: 400;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .medium {
        /* Montserrat Medium = 500 */
        font-weight: 500;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .semibold {
        /* Montserrat Semi-bold = 600 */
        font-weight: 600;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .bold {
        /* Montserrat Bold = 700 */
        font-weight: 700;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .extrabold {
        /* Montserrat Extra Bold = 800 */
        font-weight: 800;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .black {
        /* Montserrat Black = 900 */
        font-weight: 900;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }

    body {
        margin: 0cm 0cm;
        font-size: 12px;
        font-family: 'Open Sans', sans-serif;
    }

    pre {
      font-family: 'Open Sans', sans-serif;
    }

  /* Styles go here */

.page-header, .page-header-space {
  height: 262px;

}

.page-footer, .page-footer-space {
  height: 262px ;
}

.cabecera {
    display: flex;
    height: 100px;
    width: 100%;
}

.nameInfo {
    color: black;
    font-weight: bold;
}

.answerInfo {
      color: #616161;
      font-weight: 500;
      padding-Left:4px;
}

.table-cabecera-name {
  width:33%;  
  text-align: start;
  text-decoration: underline;
  padding: 5px 0 15px 0;
  font-weight: 700;
  font-size: 11px;

}

.page-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 150px !important;

  border-top: 1px solid black; /* for demo */
}

.page-header {
  position: fixed;
  width: 100%;
}

.tr-analisis {
    color: #000000;

}

.tr-sub-analisis {
    color: #000000;
}

.underlined-row {
    background-color: #F8F8F8;
}

.custom-section {
  padding: 20px 50px 0px 50px;
}

.name-analisis {
  font-weight: 700;
  font-size:14px;
  text-transform: uppercase;
}

.name-sub-analisis {
    
    text-transform: uppercase;
}

.table-answer-tr {
    font-size: 15px;
}

.paralelogramo {
    border-right: 15px solid transparent;
    border-top: 20px solid #45a02b;
    margin-right:-8.5px;
    margin-top: 7px;
}

.paralelogramo1 {

    border-left: 15px solid transparent;
    border-bottom: 20px solid #27b5d4;
    margin-left:-8.5px;
  }

.page {
  page-break-after: always;
}

@page {
  margin: 20mm
}

footer {
    position: fixed;
    bottom: 0;
    width: 100%;
  }

@media print {
   thead {display: table-header-group;} 
   tfoot {display: table-footer-group;}
   
   button {display: none;}
   
   body {margin: 0;}
} 
</style>
`;

{/* <img src="img/tomolab-logo.png" alt="logo" style="width: 80%; height: 80%;"></img> */}

{/* <label style="color:#45a02b; font-size: 17px; font-weight: 600; width:40%;">
                  Laboratorio de Análisis Clínicos
                </label> */}

    const section01 = `
    <section style="padding: 10px 50px 0px 50px; padding-right:0 !important" >
      <div class="cabecera" >
          <!-- logos -->
          <div style="display:flex; width: 40%;">
              <div style="display:flex; width: 80%; height: 90%;">
                  
              </div>
          </div>

          <div style="display:flex; width: 60%; text-align: end; margin-right: 45px">
            <div style="width: 100%">
              <img src="img/last_logo-tomolab.png" alt="logo" style="width: 70%; height: 110%;"></img>
              <div style="display:flex; justify-content: end; width: 100%">
                
              </div>
            </div>
          </div>
      </div>
      <div id="title" style="display:flex; margin:20px 45px 0 45px; justify-content: center;">
        <label style="color:#45a02b;font-size: 22px; font-weight: 700; ">
          INFORME DE RESULTADOS
        </label>
      <div>

    </section>
    `;

    const section02 = `
    <section style="padding: 10px 70px 0px 70px;">
        <div style="display: flex; width: 100%;">
            <div style="display: flex; flex-direction: column; width: 100%; font-size: 12px; font-weight: bold;">
                  
                <div style="display: flex; align-items: center;">
                    <div style=" display: flex; width: 60%;">
                      <label for="" class="nameInfo">PACIENTE : </label>
                      <label for="" class="answerInfo">${
                        customer.fullname ? customer.fullname : ""
                      }</label>
                    </div>
                </div>

                <div style="display: flex; align-items: center; padding-top:4px;">
                    <label for="" class="nameInfo">MEDICO / SOLICITANTE  : </label>
                    <label for="" class="answerInfo">${
                      doctor ? doctor.fullname : ""
                    }</label>
                </div>

                

                <div style="display: flex; margin-top:4px; align-items: center;">
                    <div style=" display: flex; width: 65%; align-items: center;">
                      <label for="" class="nameInfo">EDAD : </label>
                      <label for="" class="answerInfo">${edad} años</label>
                    </div>
                </div>

                <div style="display: flex; margin-top:4px; align-items: center;">
                    <div style=" display: flex; width: 65%; align-items: center;">
                      <label for="" class="nameInfo">${customer.type_document.name} : </label>
                      <label for="" class="answerInfo">${
                        customer.document ? customer.document : ""
                      }</label>
                    </div>
                    
                </div>
                <div style="display: flex; align-items: center; padding-top:4px;">
                    <div style=" display: flex; width: 40%; align-items: center;">
                      <label for="" class="nameInfo">FEC/HORA T.M : </label>
                      <label for="" class="answerInfo"> ${dateWithHour ? dateWithHour+' HRS' : '___-___-_____/ ___:___ HRS'} </label>
                    </div>
                    <div style=" display: flex; width: 60%; align-items: center;">
                      <label for="" class="nameInfo">FEC. EMISIÓN : </label>
                      <label for="" class="answerInfo"> ${day} HRS</label>
                    </div>

                </div>
            </div>
        </div>



    </section>`;

    const section03 = `
    <section style="padding: 0px 70px 5px 70px; ">
            <table style="width: 100%; font-size:11px;">
                <thead>
                    <tr>
                      <th class="table-cabecera-name" style="width: 38% !important">ANÁLISIS</th>
                      <th class="table-cabecera-name" style="width: 31% !important">RESULTADOS</th>
                      <th class="table-cabecera-name" style="">RANGO REFERENCIAL</th>
                    </tr>
                </thead>
                <tbody style="font-size:10px;">
                    ${content}
                </tbody>
                <div style="position:absolute; top:600px; left:50px; ">
                  <img src="img/Tomolab-marca-agua.png" alt="logo" style="width: 120%; height: 120%;"></img>
                </div>
            </table>
            <div style="display:flex; justify-content: center;">
              ${imgCompleta}
            </div>
            
        </section>
    `;

    const footer = `
    <footer >

      <div style="display: flex; width:100%; justify-content: space-between; padding-bottom:10px; margin: 0px 45px 0px 45px; align-items: end">
        <div style="display:flex; flex-direction: column; width:50%; padding-left:10%;">
          <label style="font-size: 11px; font-weight: bold;">QR Evite Falsificaciones</label>
          <div style="display:flex; width:80px; height:75px; margin-top:2px; margin-left:5%;">
            <img src="${qr.image.src}" style="width: 100%; height: 100%;"></img>
          </div>
        </div>

        <div style="display:flex; width:50%; justify-content: center; align-items: end;">
          <div style="text-align: end; padding-right: 8%;">
              <img src="img/firma_doctor-background.png" alt="firma" style="width: 180px; height: 100px;">
          </div>
        </div>
      </div>

      <div style="width:100%; ">
        <div style="display: flex; padding: 0 65px 0px 70px;">
          <div class="paralelogramo" style="width:65%; height:7px"></div>
          <div class="paralelogramo1" style="width:35%; height:7px"></div>
        </div>
      </div>

      <div style="width:100%;">
        <div style="display: flex; padding: 0 45px 10px 45px;">
          <div style="display:flex; padding: 0 15px 30px 15px; font-size:11px; justify-content: space-around">
            <div style="display:flex; width:40%; flex-direction: column;">
              <label style="color: #45a02b; font-weight:700 ">SEDES TRUJILLO:</label>
              <label style="color: #27b5d4">- Calle Colombia 109 - Urb. El Recreo</label>
              <label style="color: #27b5d4">- Av. Mansiche 875 Urb. Sánchez Carrión</label>
              <label style="color: #27b5d4">- Los Laureles 537 - Urb. California </label>
              <label style="color: #27b5d4">Tel.: (044) 611963 - 965 484 982 / 913 338 434</label>
            </div>
            <div style="display:flex; width:20%; flex-direction: column;">
              <label style="color: #45a02b; font-weight:700">SEDE CAJAMARCA:</label>
              <label style="color: #27b5d4">- Av. Mario Urteaga 445 Tel.: 949 269 707</label>
            </div>
            <div style="display:flex; width:20%; flex-direction: column;">
              <label style="color: #45a02b; font-weight:700">SEDE CHEPÉN:</label>
              <label style="color: #27b5d4">- Calle Lima 652 - 656 Tel.: 991 664 332</label>
            </div>
          </div>
        </div>
      </div>
      
    </footer>`;

    return (
      `<head>
    <script src="https://unpkg.com/qrious@4.0.2/dist/qrious.js"></script>
    <script src="js/JsBarcode.all.min.js"></script>
    </head>` +
      styleAux +
      `<body>
      

      <div class="page-header">
        <header >
            ${section01}
            
            <!-- info de paciente -->
            ${section02}
        </header>
      </div>

      <table style=" width:100%;">

        <thead>
          <tr>
            <td>
              <div class="page-header-space"></div>
            </td>
          </tr>
        </thead>

        <tbody >
          <tr >
            <td >
            ${section03}
            </td>
          </tr>
        </tbody>

        <tfoot>
          <tr>
            <td>
              <div class="page-footer-space">
              
              </div>
            </td>
          </tr>
        </tfoot>

      </table>
      ${footer}
    </body>
    <script>
      JsBarcode("#barcode", "${codigo}", {
        format: "CODE39",
        lineColor: "#000",
        width: 1.2,
        height: 30,
        displayValue: false
      });
    </script>
    `
    );
  },

  printInformarSinDisenio(prosecution) {

    const office = prosecution.office;
    const company = prosecution.office.company;
    const procesamiento = prosecution.procesamiento;
    const venta = prosecution.venta;
    const customer = prosecution.venta.customer;
    const doctor = prosecution.venta.doctor;
    const procesamientoDetalle = prosecution.procesamientoDetalle;
    const history = prosecution.history;
    const imagen_url = prosecution.procesamiento?.nameFile
      ? prosecution.procesamiento.routeFile +
        prosecution.procesamiento?.nameFile
      : "";
    let imgCompleta = "";

    if (imagen_url.length > 0) {
      // if (imgBase64) {
      
      imgCompleta = `<img src="${process.env.VUE_APP_API_URL_BASE + "/" +  imagen_url}" alt="logo_img" style="width: 450px; height: 300px; margin-top:30px;">`;

    }

    const color1 = "#048A00"; // ? color green
    // const color1 = "#C40E0E"; // ? color red
    const color2 = "#00BAD3"; // ? color blue
    const color3 = "#9C9C9C"; // ? color gray

    const calcularEdad = (fecha) => {
      var hoy = new Date();
      var cumpleanos = new Date(fecha);
      var edad = hoy.getFullYear() - cumpleanos.getFullYear();
      var m = hoy.getMonth() - cumpleanos.getMonth();

      if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
        edad--;
      }

      return edad;
    };

    const edad = calcularEdad(customer.born_date);

    const formatDate = (date, hour=false) => {
      let formatted_date =
        date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();

      if(!hour)return formatted_date;
      return formatted_date + ' ' + date.toLocaleTimeString()
    };
    const day = formatDate(new Date(), true);
    // const hour = new Date().toLocaleTimeString();

    let registration_date = new Date(venta.registration_date);
    registration_date =
      formatDate(registration_date) +
      " " +
      registration_date.toLocaleTimeString();

    let procesamiento_create = new Date(procesamiento.created_at);
    procesamiento_create =
      formatDate(procesamiento_create) +
      " " +
      procesamiento_create.toLocaleTimeString();

    // ! codigo qr

    // const link = window.location.origin + `/#/validate-pdf?id_sale=${venta.id}&id_procesamiento=${procesamiento.id}`;
    // const link = 'https://resultados.tomolab.com.pe:81' + `/#/validate-pdf?id_sale=${venta.id}&id_procesamiento=${procesamiento.id}`;
    // const link = 'https://resultados.tomolab.com.pe:81' + `/#/validate-pdf?id_sale=${venta.id}&id_procesamiento=${procesamiento.id}`;
    // // console.log(link)
    // const qr = new QRious({
    //   value: link, // La URL o el texto
    //   size: 500,
    //   backgroundAlpha: 0, // 0 para fondo transparente
    //   foreground: "#000000", // Color del QR
    //   level: "H", // Puede ser L,M,Q y H (L es el de menor nivel, H el mayor)
    // });

    // setTimeout(function() {}, 800);


    // ! codigo de barras
    const codigo = "S-00" + String(venta.id);

    let date = "";
    // !obtener la fecha del history
    history.forEach((item) => {
      date =
        date +
        `<label>${
          item.prosecution
            ? formatDate(new Date(item.prosecution.date_process))
            : "-"
        }</label>`;
    });

    let dateWithHour = procesamiento.date_hora_muestra

    if(dateWithHour){
      // ! parsea fecha de toma de muestra
      if(procesamiento.hour_toma_muestra){
        dateWithHour = formatDate(new Date(dateWithHour), false)  + " " + procesamiento.hour_toma_muestra
      }else {
        dateWithHour = formatDate(new Date(dateWithHour), true)
      }
    }

    let content = "";
    let count = 1;
    const analisisForQr = []
    procesamientoDetalle.map((item) => {
      if (!item.active || !item.check) return;
      let className = "";
      if (count % 2 == 0) {
        className = "underlined-row";
      }

      let unit_name_aux = item.unit_name == "NO TIENE" || item.unit_name == null ? "" : item.unit_name 

      const rank = item.rank || "";
      let newRank = rank.replaceAll("<p>", `<label>`);
      newRank = newRank.replaceAll("</p>", ` ${unit_name_aux} </label>`);

      let description1 =  item.description1 || ""
      description1 = description1.replaceAll("<p>", "<label>");
      description1 = description1.replaceAll("</p>", "</label>");

      let description2 =  item.description2 || ""
      description2 = description2.replaceAll("<p>", "<label>");
      description2 = description2.replaceAll("</p>", "</label>");

      let sizeForDescription = "height: 15px;"
      if(description2.length > 0 && description1.length > 0) sizeForDescription = "height: 70px;"

      if(description2.length > 0 || description1.length > 0)sizeForDescription = "height: 20px;"
      
      let infoMachineInput = ""
      if(item.infoMachine && item.infoMachineInput != null){
        infoMachineInput = `
                <tr >
                  <td style="font-size: 9px;">
                    ${item.infoMachineInput}
                  </td>
                </tr>
              `
      }

      let complementaryResult = ""
      if(item.complementaryResult && item.complementaryResultInput != null){
        let complementaryResultInput = item.complementaryResultInput.replaceAll("<p", '<pre style="line-height: 2px !important;"')
        complementaryResultInput = complementaryResultInput.replaceAll("p>", "pre>")
        
        complementaryResult = `
                <tr >
                  <td colspan="3">
                    ${complementaryResultInput}
                  </td>
                </tr>
              `
      }

      let commentResult = ""
      if(item.commentResult && item.commentInput != null){
        let commentInput = item.commentInput.replaceAll("<p", '<pre style="line-height: 2px !important;"')
        commentInput = commentInput.replaceAll("p>", "pre>")
        
        commentResult = `
                <tr >
                  <td colspan="3" >
                    ${commentInput}
                  </td>
                </tr>
              `
      }

      // ! cuando es cabecera
      // if (item.service_detail_id == null) {
      if (item.index == -1) {
        // ! cuando es compuesto
        if (item.iscompound == "on ") {
          let band = false;

          // const moreServiceWithId = procesamientoDetalle.filter((dt)=> dt.service_id == item.service_id && dt.check)
          
          // if(moreServiceWithId.length > 1){

          const moreServiceWithId = procesamientoDetalle.filter((dt)=> dt.prosecution_detail_id == item.id && dt.index != -1)
          if(moreServiceWithId.length > 0){
            console.log(moreServiceWithId)
            // si hay prosecution_detail_id -> referencias
            // ahora verificar cuales estan activas
            const moreServiceWithIdActivas = moreServiceWithId.filter((dt)=> dt.check)
            if(moreServiceWithIdActivas.length > 0) band = true
          }else {
            const moreServiceWithId = procesamientoDetalle.filter((dt)=> dt.service_id == item.service_id && dt.check && dt.index != -1)
            if(moreServiceWithId.length > 1) band = true;
          }

          if(band){
            analisisForQr.push(item)
            content = content +
            `<tr class="tr-analisis">
            <td  style="padding:5px 0;" class="name-sub-analisis"> 
            <div style="padding-bottom: 5px;">
            <label class="name-analisis " style="font-size: 11px !important; "> ${item.name} </label>
            <div style="display:flex; flex-direction: column; font-size: 9px;">
            ${description1}
            ${description2}
            </div>  
            </div>
            </td>
            </tr>`;
          }
        
        } else {
          analisisForQr.push(item)
          content =
            content + `
            
            <tr class="tr-analisis " >
              <td colspan="3">
                <table style="width: 100%;">
                  <tbody style="width: 100%;">
                    <tr>
                      <td class="name-sub-analisis" style="width:38%;">
                        <div style="display:flex; flex-direction: column;">
                          <label style="font-size: 11px !important; font-weight:700; font-weight:700;">
                            ${item.name}
                          </label>
                        </div>  
                      </td>
                      <td class="table-answer-tr"  rowspan="3" style="width:31%; font-size:11px !important; " valign="bottom">
                          ${item.result ? item.result : ""} ${ " "} ${unit_name_aux}  
                      </td>
                      <td class="table-answer-tr"  rowspan="3" style=" font-size:10px !important; "  valign="bottom"> 
                        <div style="display: flex; flex-direction: column;">
                          ${newRank} 
                        </div>
                      </td>
                    </tr>
                    ${infoMachineInput}
                    <tr>
                      <td>
                        <div style="display:flex; flex-direction: column; font-size: 9px;">
                          ${description1}
                          ${description2}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
          </tr>
          
          ${complementaryResult}
          ${commentResult}
          `;
        }
      } else {
        // ! cuando es subanalisis
        content =
          content +
          ` 
          ${infoMachineInput}
          <tr class="tr-analisis " >
              <td colspan="3">
                <table style="width: 100%;">
                  <tbody>
                    <tr>
                      <td class="name-sub-analisis" style="width:38%;">
                        <div style="display:flex; flex-direction: column;">
                          <label style="font-size: 11px !important;">
                            ${item.name}
                          </label>
                        </div>  
                      </td>
                      <td class="table-answer-tr"  rowspan="3" style="width:31%; font-size:11px !important; " valign="bottom">
                          ${item.result ? item.result : ""} ${ " "} ${unit_name_aux }  
                      </td>
                      <td class="table-answer-tr"  rowspan="3" style=" font-size:10px !important; "  valign="bottom"> 
                        <div style="display: flex; flex-direction: column;">
                          ${newRank} 
                        </div>
                      </td> 
                    </tr>
                    ${infoMachineInput}
                    <tr>
                      <td>
                        <div style="display:flex; flex-direction: column; font-size: 9px;">
                          ${description1}
                         
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div style="display:flex; flex-direction: column; font-size: 9px;">
                        ${description2}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
          </tr>
          
          ${complementaryResult}
          ${commentResult}
        `;
      }

      count++;
    });

     // ! codigo qr

     let paramsForQr = ""
     analisisForQr.map((dt)=> {
       if(paramsForQr.length > 2) paramsForQr = paramsForQr + "," + dt.name
       else paramsForQr = dt.name
     })
 
     // const link = window.location.origin + `/#/validate-pdf?id_sale=${venta.id}&id_procesamiento=${procesamiento.id}`;
     const link = 'https://resultados.tomolab.com.pe:81' + `/#/validate-pdf?id_sale=${venta.id}&id_procesamiento=${procesamiento.id}&analisis=${paramsForQr}`;
     // console.log(link)
     const qr = new QRious({
       value: link, // La URL o el texto
       size: 500,
       backgroundAlpha: 0, // 0 para fondo transparente
       foreground: "#000000", // Color del QR
       level: "H", // Puede ser L,M,Q y H (L es el de menor nivel, H el mayor)
     });

    // <tr class="tr-analisis ">
    //         <td class="name-analisis name-sub-analisis" >
    //           <div>
    //             <label class="name-analisis " style="font-size: 11px !important;"> ${item.name} </label>
    //             <div style="display:flex; flex-direction: column; font-size: 9px; ">
    //                 ${description1}
    //                 ${description2}
    //             </div>  
    //           </div>  
    //           </td>
    //         <td class="table-answer-tr" style="font-size:11px !important;">${item.result ? item.result : ""}  ${ " "} ${item.unit_name ? item.unit_name : ""}</td>
    //         <td class="table-answer-tr" style="font-size:10px !important; display: flex; flex-direction: column; padding:3px 0 3px 5px;"> ${newRank} </td>      
    //       </tr>

    const styleAux = `
  <style type="text/css" media="screen, print">

  @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

    .thin {
        /* Montserrat Thin = 100 */
        font-weight: 100;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    .extralight {
        /* Montserrat Extra Light = 200 */
        font-weight: 200;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .light {
        /* Montserrat Light = 300 */
        font-weight: 300;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .regular {
        /* Montserrat Regular = 400 */
        font-weight: 400;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .medium {
        /* Montserrat Medium = 500 */
        font-weight: 500;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .semibold {
        /* Montserrat Semi-bold = 600 */
        font-weight: 600;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .bold {
        /* Montserrat Bold = 700 */
        font-weight: 700;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .extrabold {
        /* Montserrat Extra Bold = 800 */
        font-weight: 800;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }
    
    
    .black {
        /* Montserrat Black = 900 */
        font-weight: 900;
        font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
    }

    body {
        margin: 0cm 0cm;
        font-size: 12px;
        font-family: 'Open Sans', sans-serif;
    }

  /* Styles go here */

.page-header, .page-header-space {
  height: 272px;

}

.page-footer, .page-footer-space {
  height: 262px ;
}

.cabecera {
    display: flex;
    height: 100px;
    width: 100%;
}

.nameInfo {
    color: black;
    font-weight: bold;
}

.answerInfo {
      color: #616161;
      font-weight: 500;
      padding-Left:4px;
}

.table-cabecera-name {
  width:33%;  
  text-align: start;
  text-decoration: underline;
  padding: 5px 0 15px 0;
  font-weight: 700;
  font-size: 11px;

}

.page-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 150px !important;

  border-top: 1px solid black; /* for demo */
}

.page-header {
  position: fixed;
  width: 100%;
}

.tr-analisis {
    color: #000000;

}

.tr-sub-analisis {
    color: #000000;
}

.underlined-row {
    background-color: #F8F8F8;
}

.custom-section {
  padding: 20px 50px 0px 50px;
}

.name-analisis {
  font-weight: 700;
  font-size:14px;
  text-transform: uppercase;
}

.name-sub-analisis {
    
    text-transform: uppercase;
}

.table-answer-tr {
    font-size: 15px;
}

.paralelogramo {
    border-right: 15px solid transparent;
    border-top: 20px solid #45a02b;
    margin-right:-8.5px;
    margin-top: 7px;
}

.paralelogramo1 {

    border-left: 15px solid transparent;
    border-bottom: 20px solid #27b5d4;
    margin-left:-8.5px;
  }

.page {
  page-break-after: always;
}

@page {
  margin: 20mm
}

footer {
    position: fixed;
    bottom: 0;
    width: 100%;
  }

@media print {
   thead {display: table-header-group;} 
   tfoot {display: table-footer-group;}
   
   button {display: none;}
   
   body {margin: 0;}
} 
</style>
`;


    const section01 = `
    <section style="padding: 10px 50px 0px 50px; padding-right:0 !important" >
      <div class="cabecera" >
          <!-- logos -->
          <div style="display:flex; width: 40%;">
              <div style="display:flex; width: 80%; height: 90%;">
                  
              </div>
          </div>

          <div style="display:flex; width: 60%; text-align: end; margin-right: 45px">
            <div style="width: 100%">
              
              <div style="display:flex; justify-content: end; width: 100%">
                
              </div>
            </div>
          </div>
      </div>
      <div id="title" style="display:flex; margin:20px 45px 0 45px; justify-content: center; padding-top:25px">
        <label style="color:#45a02b;font-size: 22px; font-weight: 700; ">
          
        </label>
      <div>

    </section>
    `;

    const section02 = `
    <section style="padding: 10px 70px 0px 70px;">
        <div style="display: flex; width: 100%;">
            <div style="display: flex; flex-direction: column; width: 100%; font-size: 12px; font-weight: bold;">
                  
                <div style="display: flex; align-items: center;">
                    <div style=" display: flex; width: 60%;">
                      <label for="" class="nameInfo">PACIENTE : </label>
                      <label for="" class="answerInfo">${
                        customer.fullname ? customer.fullname : ""
                      }</label>
                    </div>
                </div>

                <div style="display: flex; align-items: center; padding-top:4px;">
                    <label for="" class="nameInfo">MEDICO / SOLICITANTE  : </label>
                    <label for="" class="answerInfo">${
                      doctor ? doctor.fullname : ""
                    }</label>
                </div>

                

                <div style="display: flex; margin-top:4px; align-items: center;">
                    <div style=" display: flex; width: 65%; align-items: center;">
                      <label for="" class="nameInfo">EDAD : </label>
                      <label for="" class="answerInfo">${edad} años</label>
                    </div>
                </div>

                <div style="display: flex; margin-top:4px; align-items: center;">
                    <div style=" display: flex; width: 65%; align-items: center;">
                      <label for="" class="nameInfo">${customer.type_document.name} : </label>
                      <label for="" class="answerInfo">${
                        customer.document ? customer.document : ""
                      }</label>
                    </div>
                    
                </div>
                <div style="display: flex; align-items: center; padding-top:4px;">
                    <div style=" display: flex; width: 40%; align-items: center;">
                      <label for="" class="nameInfo">FEC/HORA T.M : </label>
                      <label for="" class="answerInfo"> ${dateWithHour ? dateWithHour+' HRS' : '___-___-_____/ ___:___ HRS'} </label>
                    </div>
                    <div style=" display: flex; width: 60%; align-items: center;">
                      <label for="" class="nameInfo">FEC. EMISIÓN : </label>
                      <label for="" class="answerInfo"> ${day} HRS</label>
                    </div>

                </div>
            </div>
        </div>



    </section>`;

    const section03 = `
    <section style="padding: 0px 70px 5px 70px; ">
            <table style="width: 100%; font-size:11px;">
                <thead>
                    <tr>
                      <th class="table-cabecera-name" style="width: 38% !important">ANÁLISIS</th>
                      <th class="table-cabecera-name" style="width: 31% !important">RESULTADOS</th>
                      <th class="table-cabecera-name" style="">RANGO REFERENCIAL</th>
                    </tr>
                </thead>
                <tbody style="font-size:10px;">
                    ${content}
                </tbody>
                
            </table>
            <div style="display:flex; justify-content: center;">
              ${imgCompleta}
            </div>
            
        </section>
    `;

    const footer = `
    <footer >

      <div style="display: flex; width:100%; justify-content: space-between; padding-bottom:10px; margin: 0px 45px 0px 45px; align-items: end">
        <div style="display:flex; flex-direction: column; width:50%; padding-left:10%;">
          <label style="font-size: 11px; font-weight: bold;">QR Evite Falsificaciones</label>
          <div style="display:flex; width:80px; height:75px; margin-top:2px; margin-left:5%;">
            <img src="${qr.image.src}" style="width: 100%; height: 100%;"></img>
          </div>
        </div>

        <div style="display:flex; width:50%; justify-content: center; align-items: end;">
          <div style="text-align: end; padding-right: 8%;">
              <img src="img/firma_doctor-background.png" alt="firma" style="width: 180px; height: 100px;">
          </div>
        </div>
      </div>

      <div style="width:100%; ">
        <div style="display: flex; padding: 0 65px 52px 70px;">
          
        </div>
      </div>

      <div style="width:100%;">
        <div style="display: flex; padding: 0 45px 52px 45px;">
          <div style="display:flex; padding: 0 15px 30px 15px; font-size:11px; justify-content: space-around">
            
            
           
          </div>
        </div>
      </div>
      
    </footer>`;

    return (
      `<head>
    <script src="https://unpkg.com/qrious@4.0.2/dist/qrious.js"></script>
    <script src="js/JsBarcode.all.min.js"></script>
    </head>` +
      styleAux +
      `<body>
      

      <div class="page-header">
        <header >
            ${section01}
            
            <!-- info de paciente -->
            ${section02}
        </header>
      </div>

      <table style=" width:100%;">

        <thead>
          <tr>
            <td>
              <div class="page-header-space"></div>
            </td>
          </tr>
        </thead>

        <tbody >
          <tr >
            <td >
            ${section03}
            </td>
          </tr>
        </tbody>

        <tfoot>
          <tr>
            <td>
              <div class="page-footer-space">
              
              </div>
            </td>
          </tr>
        </tfoot>

      </table>
      ${footer}
    </body>
    <script>
      JsBarcode("#barcode", "${codigo}", {
        format: "CODE39",
        lineColor: "#000",
        width: 1.2,
        height: 30,
        displayValue: false
      });
    </script>
    `
    );
  },

//   printInformarSinDisenio(prosecution) {

//     const office = prosecution.office;
//     const company = prosecution.office.company;
//     const procesamiento = prosecution.procesamiento;
//     const venta = prosecution.venta;
//     const customer = prosecution.venta.customer;
//     const doctor = prosecution.venta.doctor;
//     const procesamientoDetalle = prosecution.procesamientoDetalle;
//     const history = prosecution.history;
//     const imagen_url = prosecution.procesamiento?.nameFile
//       ? prosecution.procesamiento.routeFile +
//         prosecution.procesamiento?.nameFile
//       : "";
//     let imgCompleta = "";

//     if (imagen_url.length > 0) {
//       // if (imgBase64) {
      
//       imgCompleta = `<img src="${process.env.VUE_APP_API_URL_BASE + "/" +  imagen_url}" alt="logo_img" style="width: 450px; height: 300px; margin-top:30px;">`;

//     }

//     const color1 = "#048A00"; // ? color green
//     // const color1 = "#C40E0E"; // ? color red
//     const color2 = "#00BAD3"; // ? color blue
//     const color3 = "#9C9C9C"; // ? color gray

//     const calcularEdad = (fecha) => {
//       var hoy = new Date();
//       var cumpleanos = new Date(fecha);
//       var edad = hoy.getFullYear() - cumpleanos.getFullYear();
//       var m = hoy.getMonth() - cumpleanos.getMonth();

//       if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
//         edad--;
//       }

//       return edad;
//     };

//     const edad = calcularEdad(customer.born_date);

//     const formatDate = (date, hour=false) => {
//       let formatted_date =
//         date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();

//       if(!hour)return formatted_date;
//       return formatted_date + ' ' + date.toLocaleTimeString()
//     };
//     const day = formatDate(new Date(), true);
//     // const hour = new Date().toLocaleTimeString();

//     let registration_date = new Date(venta.registration_date);
//     registration_date =
//       formatDate(registration_date) +
//       " " +
//       registration_date.toLocaleTimeString();

//     let procesamiento_create = new Date(procesamiento.created_at);
//     procesamiento_create =
//       formatDate(procesamiento_create) +
//       " " +
//       procesamiento_create.toLocaleTimeString();

//     // ! codigo qr

//     const link =
//       window.location.origin +
//       `/#/validate-pdf?id_sale=${venta.id}&id_procesamiento=${procesamiento.id}`;
//     const qr = new QRious({
//       value: link, // La URL o el texto
//       size: 500,
//       backgroundAlpha: 0, // 0 para fondo transparente
//       foreground: "#000000", // Color del QR
//       level: "H", // Puede ser L,M,Q y H (L es el de menor nivel, H el mayor)
//     });

//     setTimeout(function() {}, 800);


//     // ! codigo de barras
//     const codigo = "S-00" + String(venta.id);

//     let date = "";
//     // !obtener la fecha del history
//     history.forEach((item) => {
//       date =
//         date +
//         `<label>${
//           item.prosecution
//             ? formatDate(new Date(item.prosecution.date_process))
//             : "-"
//         }</label>`;
//     });

//     let dateWithHour = procesamiento.date_hora_muestra

//     if(dateWithHour){
//       // ! parsea fecha de toma de muestra
//       if(procesamiento.hour_toma_muestra){
//         dateWithHour = formatDate(new Date(dateWithHour), false)  + " " + procesamiento.hour_toma_muestra
//       }else {
//         dateWithHour = formatDate(new Date(dateWithHour), true)
//       }
//     }

//     let content = "";
//     let count = 1;
//     procesamientoDetalle.map((item) => {
//       if (!item.active || !item.check) return;
//       let className = "";
//       if (count % 2 == 0) {
//         className = "underlined-row";
//       }

//       let unit_name_aux = item.unit_name == "NO TIENE" || item.unit_name == null ? "" : item.unit_name 

//       const rank = item.rank || "";
//       let newRank = rank.replaceAll("<p>", `<label>`);
//       newRank = newRank.replaceAll("</p>", ` ${unit_name_aux} </label>`);

//       let description1 =  item.description1 || ""
//       description1 = description1.replaceAll("<p>", "<label>");
//       description1 = description1.replaceAll("</p>", "</label>");

//       let description2 =  item.description2 || ""
//       description2 = description2.replaceAll("<p>", "<label>");
//       description2 = description2.replaceAll("</p>", "</label>");

//       let sizeForDescription = "height: 15px;"
//       if(description2.length > 0 && description1.length > 0) sizeForDescription = "height: 70px;"

//       if(description2.length > 0 || description1.length > 0)sizeForDescription = "height: 20px;"
      

//       // ! cuando es cabecera
//       // if (item.service_detail_id == null) {
//       if (item.index == -1) {
//         // ! cuando es compuesto
//         if (item.iscompound == "on ") {
//           content =
//             content +
//             `<tr class="tr-analisis">
//               <td  style="padding:5px 0;" class="name-sub-analisis"> 
//                 <div style="padding-bottom: 5px;">
//                   <label class="name-analisis " style="font-size: 11px !important;"> ${item.name} </label>
//                   <div style="display:flex; flex-direction: column; font-size: 9px;">
//                       ${description1}
//                       ${description2}
//                   </div>  
//                 </div>
//               </td>
//           </tr>`;
//         } else {
//           content =
//             content + `
            
//             <tr class="tr-analisis " >
//               <td colspan="3">
//                 <table style="width: 100%;">
//                   <tbody style="width: 100%;">
//                     <tr>
//                       <td class="name-sub-analisis" style="width:38%;">
//                         <div style="display:flex; flex-direction: column;">
//                           <label style="font-size: 11px !important;">
//                             ${item.name}
//                           </label>
//                         </div>  
//                       </td>
//                       <td class="table-answer-tr"  rowspan="3" style="width:31%; font-size:11px !important; " valign="bottom">
//                           ${item.result ? item.result : ""} ${ " "} ${unit_name_aux}  
//                       </td>
//                       <td class="table-answer-tr"  rowspan="3" style=" font-size:10px !important; "  valign="bottom"> 
//                         <div style="display: flex; flex-direction: column;">
//                           ${newRank} 
//                         </div>
//                       </td>
//                     </tr>
//                     <tr>
//                       <td>
//                         <div style="display:flex; flex-direction: column; font-size: 9px;">
//                           ${description1}
//                           ${description2}
//                         </div>
//                       </td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </td>
//           </tr>
//           `;
//         }
//       } else {
//         // ! cuando es subanalisis
//         content =
//           content +
//           ` <tr class="tr-analisis " >
//               <td colspan="3">
//                 <table style="width: 100%;">
//                   <tbody>
//                     <tr>
//                       <td class="name-sub-analisis" style="width:38%;">
//                         <div style="display:flex; flex-direction: column;">
//                           <label style="font-size: 11px !important;">
//                             ${item.name}
//                           </label>
//                         </div>  
//                       </td>
//                       <td class="table-answer-tr"  rowspan="3" style="width:31%; font-size:11px !important; " valign="bottom">
//                           ${item.result ? item.result : ""} ${ " "} ${unit_name_aux }  
//                       </td>
//                       <td class="table-answer-tr"  rowspan="3" style=" font-size:10px !important; "  valign="bottom"> 
//                         <div style="display: flex; flex-direction: column;">
//                           ${newRank} 
//                         </div>
//                       </td> 
//                     </tr>
//                     <tr>
//                       <td>
//                         <div style="display:flex; flex-direction: column; font-size: 9px;">
//                           ${description1}
                         
//                         </div>
//                       </td>
//                     </tr>
//                     <tr>
//                       <td>
//                         <div style="display:flex; flex-direction: column; font-size: 9px;">
//                         ${description2}
//                         </div>
//                       </td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </td>
//           </tr>
//         `;
//       }

//       count++;
//     });

//     // <tr class="tr-analisis ">
//     //         <td class="name-analisis name-sub-analisis" >
//     //           <div>
//     //             <label class="name-analisis " style="font-size: 11px !important;"> ${item.name} </label>
//     //             <div style="display:flex; flex-direction: column; font-size: 9px; ">
//     //                 ${description1}
//     //                 ${description2}
//     //             </div>  
//     //           </div>  
//     //           </td>
//     //         <td class="table-answer-tr" style="font-size:11px !important;">${item.result ? item.result : ""}  ${ " "} ${item.unit_name ? item.unit_name : ""}</td>
//     //         <td class="table-answer-tr" style="font-size:10px !important; display: flex; flex-direction: column; padding:3px 0 3px 5px;"> ${newRank} </td>      
//     //       </tr>

//     const styleAux = `
//   <style type="text/css" media="screen, print">

//   @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

//     .thin {
//         /* Montserrat Thin = 100 */
//         font-weight: 100;
//         font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
//     }
    
//     .extralight {
//         /* Montserrat Extra Light = 200 */
//         font-weight: 200;
//         font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
//     }
    
    
//     .light {
//         /* Montserrat Light = 300 */
//         font-weight: 300;
//         font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
//     }
    
    
//     .regular {
//         /* Montserrat Regular = 400 */
//         font-weight: 400;
//         font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
//     }
    
    
//     .medium {
//         /* Montserrat Medium = 500 */
//         font-weight: 500;
//         font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
//     }
    
    
//     .semibold {
//         /* Montserrat Semi-bold = 600 */
//         font-weight: 600;
//         font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
//     }
    
    
//     .bold {
//         /* Montserrat Bold = 700 */
//         font-weight: 700;
//         font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
//     }
    
    
//     .extrabold {
//         /* Montserrat Extra Bold = 800 */
//         font-weight: 800;
//         font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
//     }
    
    
//     .black {
//         /* Montserrat Black = 900 */
//         font-weight: 900;
//         font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
//     }

//     body {
//         margin: 0cm 0cm;
//         font-size: 12px;
//         font-family: 'Open Sans', sans-serif;
//     }

//   /* Styles go here */

// .page-header, .page-header-space {
//   height: 262px;

// }

// .page-footer, .page-footer-space {
//   height: 260px ;
// }

// .cabecera {
//     display: flex;
//     height: 100px;
//     width: 100%;
// }

// .nameInfo {
//     color: black;
//     font-weight: bold;
// }

// .answerInfo {
//       color: #616161;
//       font-weight: 500;
//       padding-Left:4px;
// }

// .table-cabecera-name {
//   width:33%;  
//   text-align: start;
//   text-decoration: underline;
//   padding: 5px 0 15px 0;
//   font-weight: 700;
//   font-size: 11px;

// }

// .page-footer {
//   position: fixed;
//   bottom: 0;
//   width: 100%;
//   height: 150px !important;

//   border-top: 1px solid black; /* for demo */
// }

// .page-header {
//   position: fixed;
//   width: 100%;
// }

// .tr-analisis {
//     color: #000000;

// }

// .tr-sub-analisis {
//     color: #000000;
// }

// .underlined-row {
//     background-color: #F8F8F8;
// }

// .custom-section {
//   padding: 20px 50px 0px 50px;
// }

// .name-analisis {
//   font-weight: 700;
//   font-size:14px;
//   text-transform: uppercase;
// }

// .name-sub-analisis {
    
//     text-transform: uppercase;
// }

// .table-answer-tr {
//     font-size: 15px;
// }

// .paralelogramo {
//     border-right: 15px solid transparent;
//     border-top: 20px solid #45a02b;
//     margin-right:-8.5px;
//     margin-top: 10px;
// }

// .paralelogramo1 {

//     border-left: 15px solid transparent;
//     border-bottom: 20px solid #27b5d4;
//     margin-left:-8.5px;
//   }

// .page {
//   page-break-after: always;
// }

// @page {
//   margin: 20mm
// }

// footer {
//     position: fixed;
//     bottom: 0;
//     width: 100%;
//   }

// @media print {
//    thead {display: table-header-group;} 
//    tfoot {display: table-footer-group;}
   
//    button {display: none;}
   
//    body {margin: 0;}
// } 
// </style>
// `;

// {/* <img src="img/tomolab-logo.png" alt="logo" style="width: 80%; height: 80%;"></img> */}

// {/* <label style="color:#45a02b; font-size: 17px; font-weight: 600; width:40%;">
//                   Laboratorio de Análisis Clínicos
//                 </label> */}

//                 // <img src="img/last_logo-tomolab.png" alt="logo" style="width: 70%; height: 110%;"></img>

//     const section01 = `
//     <section style="padding: 10px 50px 0px 50px; padding-right:0 !important" >
//       <div class="cabecera" >
//           <!-- logos -->
//           <div style="display:flex; width: 40%;">
//               <div style="display:flex; width: 80%; height: 90%;">
                  
//               </div>
//           </div>

//           <div style="display:flex; width: 60%; text-align: end; margin-right: 45px">
//             <div style="width: 100%">
              
//               <div style="display:flex; justify-content: end; width: 100%; ">
                
//               </div>
//             </div>
//           </div>
//       </div>
//       <div id="title" style="display:flex; margin:20px 45px 0 45px; justify-content: center;">
//         <label style="color:#45a02b;font-size: 22px; font-weight: 700; height:37px;">
          
//         </label>
//       <div>

//     </section>
//     `;

//     const section02 = `
//     <section style="padding: 14px 70px 0px 70px;">
//         <div style="display: flex; width: 100%;">
//             <div style="display: flex; flex-direction: column; width: 100%; font-size: 12px; font-weight: bold;">
                  
//                 <div style="display: flex; align-items: center;">
//                     <div style=" display: flex; width: 60%;">
//                       <label for="" class="nameInfo">PACIENTE : </label>
//                       <label for="" class="answerInfo">${
//                         customer.fullname ? customer.fullname : ""
//                       }</label>
//                     </div>
//                 </div>

//                 <div style="display: flex; align-items: center; padding-top:4px;">
//                     <label for="" class="nameInfo">MEDICO / SOLICITANTE  : </label>
//                     <label for="" class="answerInfo">${
//                       doctor ? doctor.fullname : ""
//                     }</label>
//                 </div>

                

//                 <div style="display: flex; margin-top:4px; align-items: center;">
//                     <div style=" display: flex; width: 65%; align-items: center;">
//                       <label for="" class="nameInfo">EDAD : </label>
//                       <label for="" class="answerInfo">${edad} años</label>
//                     </div>
//                 </div>

//                 <div style="display: flex; margin-top:4px; align-items: center;">
//                     <div style=" display: flex; width: 65%; align-items: center;">
//                       <label for="" class="nameInfo">DNI : </label>
//                       <label for="" class="answerInfo">${
//                         customer.document ? customer.document : ""
//                       }</label>
//                     </div>
                    
//                 </div>
//                 <div style="display: flex; align-items: center; padding-top:4px;">
//                     <div style=" display: flex; width: 40%; align-items: center;">
//                       <label for="" class="nameInfo">FEC/HORA T.M : </label>
//                       <label for="" class="answerInfo"> ${dateWithHour ? dateWithHour +' HRS' : '___-___-_____/ ___:___ HRS'} </label>
//                     </div>
//                     <div style=" display: flex; width: 60%; align-items: center;">
//                       <label for="" class="nameInfo">FEC. EMISIÓN : </label>
//                       <label for="" class="answerInfo"> ${day}</label>
//                     </div>

//                 </div>
//             </div>
//         </div>



//     </section>`;

//     const section03 = `
//     <section style="padding: 0px 70px 5px 70px; ">
//             <table style="width: 100%; font-size:11px;">
//                 <thead>
//                     <tr>
//                       <th class="table-cabecera-name" style="width: 38% !important">ANÁLISIS</th>
//                       <th class="table-cabecera-name" style="width: 31% !important">RESULTADOS</th>
//                       <th class="table-cabecera-name" style="">RANGO REFERENCIAL</th>
//                     </tr>
//                 </thead>
//                 <tbody style="font-size:10px;">
//                     ${content}
//                 </tbody>
                
//             </table>
//             <div style="display:flex; justify-content: center;">
//               ${imgCompleta}
//             </div>
            
//         </section>
//     `;

//     const footer = `
//     <footer >

//       <div style="display: flex; width:100%; justify-content: space-between; padding-bottom:10px; margin: 0px 45px 0px 45px; align-items: center;">
//         <div style="display:flex; flex-direction: column; width:50%; padding-left:10%;">
//           <label style="font-size: 11px; font-weight: bold;">QR Evite Falsificaciones</label>
//           <div style="display:flex; width:80px; height:75px; margin-top:2px; margin-left:5%;">
//             <img src="${qr.image.src}" style="width: 100%; height: 100%;"></img>
//           </div>
//         </div>

//         <div style="display:flex; width:50%; justify-content: center;">
//           <div style="text-align: end; padding-right: 8%; padding-bottom: 3%;">
//               <img src="img/firma_doctor-background.png" alt="firma" style="width: 180px; height: 100px;">
//           </div>
//         </div>
//       </div>

//       <div style="width:100%; ">
//         <div style="display: flex; padding: 0 65px 57px 70px;">
          
//         </div>
//       </div>

//       <div style="width:100%;">
//         <div style="display: flex; padding: 0 45px 57px 45px;">
//           <div style="display:flex; padding: 0 15px 30px 15px; font-size:11px; justify-content: space-around">
            
//           </div>
//         </div>
//       </div>
      
//     </footer>`;

//     return (
//       `<head>
//     <script src="https://unpkg.com/qrious@4.0.2/dist/qrious.js"></script>
//     <script src="js/JsBarcode.all.min.js"></script>
//     </head>` +
//       styleAux +
//       `<body>
      

//       <div class="page-header">
//         <header >
//             ${section01}
            
//             <!-- info de paciente -->
//             ${section02}
//         </header>
//       </div>

//       <table style=" width:100%;">

//         <thead>
//           <tr>
//             <td>
//               <div class="page-header-space"></div>
//             </td>
//           </tr>
//         </thead>

//         <tbody >
//           <tr >
//             <td >
//             ${section03}
//             </td>
//           </tr>
//         </tbody>

//         <tfoot>
//           <tr>
//             <td>
//               <div class="page-footer-space">
              
//               </div>
//             </td>
//           </tr>
//         </tfoot>

//       </table>
//       ${footer}
//     </body>
//     <script>
//       JsBarcode("#barcode", "${codigo}", {
//         format: "CODE39",
//         lineColor: "#000",
//         width: 1.2,
//         height: 30,
//         displayValue: false
//       });
//     </script>
//     `
//     );
//   },


};
